import { render, staticRenderFns } from "./SafetyObservationNew.vue?vue&type=template&id=3ea296ff"
import script from "./SafetyObservationNew.vue?vue&type=script&lang=js"
export * from "./SafetyObservationNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports